export default __webpack_public_path__ + "i18n/translations/translation-it.6f52c6a9.json";